import { render, staticRenderFns } from "./TermsTextEn.vue?vue&type=template&id=598654d8&scoped=true&"
import script from "./TermsTextEn.vue?vue&type=script&lang=js&"
export * from "./TermsTextEn.vue?vue&type=script&lang=js&"
import style0 from "./TermsTextEn.vue?vue&type=style&index=0&id=598654d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598654d8",
  null
  
)

export default component.exports